// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-1-m__wrapper__3Cn-0","tags":"card-image-type-1-m__tags__VfqCM","sections":"card-image-type-1-m__sections__3dQKh"};